import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "comparison-report-page" }
const _hoisted_2 = { class: "report-header d-flex align-center justify-space-between mb-4" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"height":"400px"}
}
const _hoisted_4 = {
  key: 1,
  class: "d-flex justify-center align-center",
  style: {"height":"400px"}
}
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "mt-2 text-medium-emphasis" }
const _hoisted_7 = {
  key: 2,
  class: "report-frame-wrapper"
}
const _hoisted_8 = ["srcdoc"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, [
        _createElementVNode("h4", { class: "mb-1" }, "Sistem Karşılaştırma Raporu"),
        _createElementVNode("span", { class: "text-caption text-medium-emphasis" }, "Eski sistem (file_search) vs. Yeni sistem (MCP + pgvector)")
      ], -1)),
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "outlined",
        size: "small",
        "prepend-icon": "refresh",
        loading: _ctx.loading,
        onClick: _ctx.loadReport
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Yenile ", -1)
        ]))]),
        _: 1
      }, 8, ["loading", "onClick"])
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_v_progress_circular, {
            indeterminate: "",
            color: "primary",
            size: "48"
          })
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[3] || (_cache[3] = _createElementVNode("span", {
                class: "material-symbols-outlined",
                style: {"font-size":"48px","color":"#ccc"}
              }, "error_outline", -1)),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.error), 1),
              _createVNode(_component_v_btn, {
                color: "primary",
                variant: "tonal",
                onClick: _ctx.loadReport
              }, {
                default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                  _createTextVNode("Tekrar Dene", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("iframe", {
              ref: "reportFrame",
              srcdoc: _ctx.reportHtml,
              frameborder: "0",
              class: "report-frame",
              sandbox: "allow-scripts allow-same-origin"
            }, null, 8, _hoisted_8)
          ]))
  ]))
}